import { render, staticRenderFns } from "./UseDataDetailTable.vue?vue&type=template&id=a8207ade&"
import script from "./UseDataDetailTable.vue?vue&type=script&lang=js&"
export * from "./UseDataDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports